import apiClient from "./apiClient";
import { ensureRichTextHtml } from "../utils/riskReviewTemplate";

export const DEFAULT_CONTROL_REVIEW_TEMPLATE = {
  template_body: "<p>Control review on {{review_date}}.</p><p>{{review_changes_summary}}</p>",
};

let templateCache = null;
let templateInflight = null;

const cloneTemplate = (template) => ({
  template_body: ensureRichTextHtml(template?.template_body || DEFAULT_CONTROL_REVIEW_TEMPLATE.template_body),
});

export const clearControlReviewTemplateCache = () => {
  templateCache = null;
  templateInflight = null;
};

export const getControlReviewTemplate = async ({ force = false } = {}) => {
  if (templateCache && !force) {
    return { data: cloneTemplate(templateCache) };
  }
  if (templateInflight && !force) {
    return templateInflight;
  }

  templateInflight = apiClient
    .get("/control-review-template")
    .then((response) => {
      templateCache = cloneTemplate(response?.data || {});
      return { ...response, data: cloneTemplate(templateCache) };
    })
    .finally(() => {
      templateInflight = null;
    });

  return templateInflight;
};

export const updateControlReviewTemplate = async (payload) => {
  const response = await apiClient.put("/control-review-template", payload);
  templateCache = cloneTemplate(response?.data || {});
  return { ...response, data: cloneTemplate(templateCache) };
};
